import React from "react";

import { makeStyles, Typography } from "@material-ui/core";
import { MdCheckCircle } from "react-icons/md";

import HStack from "modules/core/components/HStack";

const useStyles = makeStyles(theme => ({
  list: {
    display: "flex",
    flexDirection: "column",
    gap: 5
  },

  icon: {
    color: theme.palette.success.main,
    lineHeight: 0
  }
}));

const items = [
  "Create new ideas and help build your backlog.",
  "Comment on any research, idea or experiment cards.",
  "Access to all dashboards & stats.",
  "Visualise experiments on the roadmap.",
  "Query Engine to find all your team's historic data."
];

const RoleAbilitiesStep = () => {
  const classes = useStyles();

  return (
    <div>
      <Typography
        variant="body2"
        color="textSecondary"
        style={{ marginBottom: 15 }}
      >
        As a viewer, here&apos;s how you can contribute to your team&apos;s
        projects and initiatives.
      </Typography>

      <div className={classes.list}>
        {items.map((item, index) => (
          <HStack gap={4} key={index}>
            <span className={classes.icon}>
              <MdCheckCircle size={18} />
            </span>

            <Typography variant="body2" color="textSecondary">
              {item}
            </Typography>
          </HStack>
        ))}
      </div>
    </div>
  );
};

export default React.memo(RoleAbilitiesStep);
